const GoogleApi = function GoogleApi(optsParam) {
  const opts = optsParam || {}

  const apiKey = opts.apiKey
  const libraries = opts.libraries || []
  const client = opts.client
  const URL = 'https://maps.googleapis.com/maps/api/js'

  // const googleVersion = '3.22'
  const googleVersion = '3.28'
  // const script = null
  // const google = (window.google = null)
  // const loading = false
  const channel = null
  const language = null
  const region = null

  // const onLoadEvents = []

  const url = () => {
    const params = {
      key: apiKey,
      callback: 'CALLBACK_NAME',
      libraries: libraries.join(','),
      client,
      v: googleVersion,
      channel,
      language,
      region,
    }

    const paramStr = Object.keys(params)
      .filter(k => !!params[k])
      .map(k => `${k}=${params[k]}`)
      .join('&')

    return `${URL}?${paramStr}`
  }

  return url()
}

export default GoogleApi



// WEBPACK FOOTER //
// ./src/components/GoogleMaps/lib/GoogleApi.js